
import { Card, CardContent } from "../components/ui/card"
import { ArrowLeft } from "lucide-react"

const AuthCard = ({ children, title, subtitle, showBackButton = false, onBack, className = "" }) => {
    return (
        <div className="lg:min-h-screen relative flex items-center justify-center p-0 bg-transparent">
            <Card
                className={`w-full sm:w-[450px] py-0 mx-auto bg-[#ffffff] border-1 rounded-t-3xl rounded-b-none sm:rounded-3xl ${className}`}
            >
                <CardContent className="p-8">
                    {showBackButton && (
                        <button
                            onClick={onBack}
                            className="mb-6 cursor-pointer"
                            style={{ color: "#1d2933" }}
                        >
                            <ArrowLeft size={24} className="transition-transform duration-300 hover:-translate-x-1" />
                        </button>
                    )}

                    <div className="mb-8">
                        <h1 className="text-2xl font-semibold mb-2" style={{ color: "#1d2933" }}>
                            {title}
                        </h1>
                        {subtitle && (
                            <p className="text-sm" style={{ color: "#60738f" }}>
                                {subtitle}
                            </p>
                        )}
                    </div>

                    {children}
                </CardContent>
            </Card>
        </div>
    )
}

export default AuthCard
